import { useQuery } from 'react-query';

import { httpService } from '../../services/http.service';
import { BASE_URL, USER } from '../../constants/endpoints';
import { useStore } from '../../store';

const { CONTROLLERS: { ACCOUNT: { BASE, ROUTES: { TRANSACTIONS: { SUB_ROUTES: { CATEGORIES } } } } } } = USER;

const { setCategoriesList } = useStore.getState();

export const useTransactionsCategoriesQuery = ({ customerId, autoRefetch = false }: { customerId: string, autoRefetch?: boolean }) => useQuery(
  'transactionsCategories',
  async () => {
    if (!customerId) {
      return null;
    }
    const { data } = await httpService.get((`${BASE_URL}/api/${CATEGORIES.VERSION}/user/${customerId}/${BASE}/${CATEGORIES.BASE}`));
    return data;
  },
  {
    onSuccess: (data) => {
      setCategoriesList(data);
      return data;
    },
    enabled: autoRefetch,
    cacheTime: 10,
    staleTime: 10 * 60 * 1000,
    refetchOnWindowFocus: false,
  },
);
